import React, { useRef, useState, useLayoutEffect } from 'react';
import { Transition } from 'react-transition-group';
import style from './style.scss';
import classNames from '../../classNames';

const animationEndEvent = typeof CSS === 'undefined' || CSS.supports('(animation:none)')
    ? 'animationend'
    : 'webkitanimationend';

export default (props) => {
    const { children, className, classNameOuter, in: inProp } = props;
    const outerContainerRef = useRef();
    const innerContainerRef = useRef();
    const [isExiting, setExiting] = useState(false);
    const [isEntered, setEntered] = useState(false);
    const [isEntering, setEntering] = useState(false);

    useLayoutEffect(() => {
        const outerContainer = outerContainerRef.current;
        const innerContainer = innerContainerRef.current;
        if (!inProp) {
            outerContainer.style.maxHeight = `${innerContainer.getBoundingClientRect().height * 2}px`;
            outerContainer.style.opacity = '1';
            outerContainer.classList.remove(style.expand);
            outerContainer.classList.add(style.contract);
        } else if (isEntered) {
            outerContainer.style.maxHeight = 'none';
            outerContainer.style.opacity = '1';
            outerContainer.classList.remove(style.expand);
            outerContainer.style.maxHeight = `${innerContainer.getBoundingClientRect().height * 2}px`;
        } else if (isEntering) {
            outerContainer.style.maxHeight = `${innerContainer.getBoundingClientRect().height * 2}px`;
            outerContainer.classList.add(style.expand);
        }
    }, [inProp, isEntered, isExiting, isEntering]);

    return <Transition in={inProp}
                       mountOnEnter={true}
                       unmountOnExit={true}
                       appear={true}
                       addEndListener={(node, done) => {
                           node.addEventListener(animationEndEvent, (event) => {
                               setEntered(true);
                               done(event);
                           });
                       }}
                       onEnter={() => setEntering(true)}
                       onExit={() => setExiting(true)}>
        <div ref={outerContainerRef} className={classNames(style.outer, classNameOuter)}>
            <div ref={innerContainerRef} className={classNames(style.inner, className)}>
                {children}
            </div>
        </div>
    </Transition>;
};
